// Filter popup popup.
//
// Each option carries the tags from its metaobject; selecting one filters the
// collection by those tags through Shopify's filter.p.tag storefront filter
// (values are OR'd). The Product tag filter must be enabled for the collection
// in Search & Discovery or the params are ignored.

const CONTAINER_SELECTOR = ".filter-popup-container";
const TAG_PARAM = "filter.p.tag";

const close = () => {
  document
    .querySelectorAll(CONTAINER_SELECTOR)
    .forEach(($container) => $container.classList.remove("active"));
  document.querySelector("body")?.classList.remove("overflow-y-hidden");
};

const open = () => {
  const $container = document.querySelector(CONTAINER_SELECTOR);
  if (!$container) {
    console.log("filter popup: no popup on this page");
    return;
  }

  $container.classList.add("active");
  document.querySelector("body")?.classList.add("overflow-y-hidden");
};

const getTags = ($option) => {
  try {
    const tags = JSON.parse($option.dataset.filterTags || "[]");
    return Array.isArray(tags) ? tags.filter(Boolean) : [];
  } catch {
    return [];
  }
};

// Replaces any tags already applied - options are mutually exclusive.
const applyTags = (tags) => {
  const url = new URL(window.location.href);

  url.searchParams.delete(TAG_PARAM);
  url.searchParams.delete("page");
  tags.forEach((tag) => url.searchParams.append(TAG_PARAM, tag));

  window.location.href = url.href;
};

export const filterPopup = () => {
  document.addEventListener("click", (event) => {
    const $target = event.target;

    if ($target.closest(".filter-popup__button")) {
      event.preventDefault();
      open();
      return;
    }

    if (
      $target.closest(".filter-popup__close") ||
      $target.closest(".filter-popup-container-bg")
    ) {
      event.preventDefault();
      close();
      return;
    }

    if ($target.closest(".filter-popup__clear")) {
      event.preventDefault();
      applyTags([]);
      return;
    }

    const $option = $target.closest(".filter-popup__option");
    if ($option) {
      event.preventDefault();
      const $container = $option.closest(CONTAINER_SELECTOR);
      const wasActive = $option.getAttribute("aria-pressed") === "true";

      $container
        .querySelectorAll(".filter-popup__option")
        .forEach(($other) => $other.setAttribute("aria-pressed", "false"));
      $option.setAttribute("aria-pressed", String(!wasActive));

      const tags = getTags($option);

      // Re-selecting the applied option clears it.
      if (wasActive) {
        applyTags([]);
      } else if (tags.length) {
        applyTags(tags);
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
};

export default filterPopup;
